function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgMicrophoneOn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    x: 7.088,
    y: 1.916,
    width: 10.511,
    height: 16.682,
    rx: 5.255,
    stroke: props.color,
    strokeWidth: 1.832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M22.371 12.957c0 5.752-4.662 10.414-10.414 10.414S1.543 18.71 1.543 12.957M12.343 23.371v6.558M17.743 30.314H6.17",
    stroke: props.color,
    strokeWidth: 1.832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgMicrophoneOn;